import {Injectable} from '@angular/core';
import {UserService} from './user.service';
import {UserDTO} from '../model/userDTO';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {

  private user: UserDTO;
  private updated = new Date();
  private maxAge = 3600000; // 1 hour

  constructor(private usersService: UserService) {
  }

  get() {
    if (!this.user || this.timeBetweenRenewals() > this.maxAge) {
      return this.renew();
    }
    return new Promise<UserDTO>(data => data(this.user));
  }

  private timeBetweenRenewals() {
    return new Date().getTime() - this.updated.getTime();
  }

  delete() {
    this.user = null;
  }

  /** BEWARE: this method changes state */
  renew() {
    return new Promise<UserDTO>(executor => {
      this.usersService.getCurrentUser().subscribe(user => {
        this.user = user;
        this.updated = new Date();
        executor(user);
      });
    });
  }
}
